import axios, {AxiosResponse} from 'axios'
import {IStopSellModel} from './StopSellModel'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const STOPSELL_CREATE_URL = `${API_URL}api/v1/definition/stopSell/create`
export const STOPSELL_GET_ALL_URL = `${API_URL}api/v1/definition/stopSell/all`
export const STOPSELL_DELETE_URL = `${API_URL}api/v1/definition/stopSell/delete/`
export const STOPSELL_UPDATE_URL = `${API_URL}api/v1/definition/stopSell/update/`

export function createStopSell(stopSellData: IStopSellModel) {
  return axios.post(STOPSELL_CREATE_URL, stopSellData)
}

export function updateStopSell(stopSellData: IStopSellModel) {
  return axios.patch(STOPSELL_UPDATE_URL + stopSellData.id, stopSellData)
}

export async function loadStopSell(
  page = 0,
  size = 5,
  sort: string = 'createdDate',
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IStopSellModel>>>> {
  return axios.get(STOPSELL_GET_ALL_URL, {
    params: {page, size, sort, order},
  })
}

export function deleteStopSell(stopSellData: string) {
  return axios.delete(STOPSELL_DELETE_URL + stopSellData)
}
